import * as SwitchRadix from "@radix-ui/react-switch";
import { Row } from "../Row";
import { Close, CheckIcon } from "@/icons";
import "./Switch.scss";

type SwitchProps = {
  id?: string;
  label?: string;
  checked?: boolean;
  name?: string;
  disabled?: boolean;
  setValue: (name: string, value: boolean) => void;
  className?: string;
};

export const Switch = ({
  id = undefined,
  label = "Visibile",
  checked = false,
  setValue,
  name,
  disabled = false,
  className,
}: SwitchProps) => {
  return (
    <Row alignItems="center" gap="x16" className={className}>
      {label && (
        <label className="text-muted fs-6 fw-bold" htmlFor={id}>
          {label}
        </label>
      )}
      <SwitchRadix.Root
        id={id}
        disabled={disabled}
        checked={checked}
        onCheckedChange={(value) => {
          setValue(name ?? "", value);
        }}
        className={"ui-switch"}
        aria-label={label}
      >
        <SwitchRadix.Thumb className={"ui-switch-thumb"}>
          {checked ? (
            <CheckIcon width={12} height={12} />
          ) : (
            <Close width={12} height={12} />
          )}
        </SwitchRadix.Thumb>
      </SwitchRadix.Root>
    </Row>
  );
};
